<template>
  <v-app>
    <div class="wrapper">
      <router-view></router-view>

      <Preloader
        v-if="isPreloaderVisible"
        title="Otimizando"
        subtitle="Estamos otimizando a interface do NewsHub para você, aguarde alguns instantes :)"
      />
    </div>
  </v-app>
</template>
<script>
import { log } from 'util';
import Preloader from '@/components/shared/Preloader.vue';

export default {
  components: {
    Preloader,
  },
  data() {
    return {
      isPreloaderVisible: false,
      windowWidth: window.innerWidth,
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.$store.dispatch('admin/getAdminVariables');
  },
  methods: {
    handleResize() {
      const clientWidth = window.innerWidth;
      if (clientWidth !== this.windowWidth) {
        this.isPreloaderVisible = true;
        this.windowWidth = clientWidth;
      }
      setTimeout(() => {
        this.isPreloaderVisible = false;
      }, 2400);
    },
  },
  mounted() {
    log(`Version: ${process.env.PACKAGE_VERSION}`);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/inputs.scss';

.v-application {
  font-family: 'globotipo' !important;
}

.wrapper {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;

  ::v-deep .container {
    width: 100%;
    max-width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;

    .v-toolbar {
      padding: 0 16px;

      @include for-size(phone-only) {
        padding: 0 16px;
      }
    }

    .v-toolbar,
    .container-box,
    .table-wrapper,
    .mirror-wrapper,
    .feedback-wrapper {
      &.side-panel {
        width: calc(100% - 400px);
        margin: 0 0 0 auto;

        @media screen and (max-width: 1263px) {
          width: 100%;
        }
      }
    }

    .v-toolbar {
      &.details {
        &.side-panel {
          margin: 0 auto 0 0;
        }
      }
    }

    .container-box {
      &.side-panel {
        padding: 0;
      }
    }

    .container-box {
      width: 100%;
      height: 100%;
      padding-top: 16px !important;

      &.no-scroll {
        overflow: hidden;
        height: 100vh;
        padding: 0 16px;
        background-color: $color-background;
        margin: 0 auto 0 0;

        @include for-size(phone-only) {
          padding: 0;
          height: 100%;
          overflow-y: auto;
        }
      }
    }

    .story-list {
      .container-box {
        padding: 8px 0 0 0 !important;
      }
    }
  }
}
</style>
